import { Modal } from '@ver-uds/react';
import React from 'react';
import AriaLink from '../../AriaLink/AriaLink';
import LinkType from '../../../constants/LinkType';
import ExternalLinks from '../../../constants/ExternalLinks';

export type TroubleshootingModalProps = {
  isOpen: boolean;
  close(): void;
};

const TroubleshootingModal = ({ isOpen, close }: TroubleshootingModalProps): JSX.Element => {
  const modalId = 'i9-troubleshooting-modal';

  const root = document.createElement('div');
  root.id = 'root';
  document.body.appendChild(root);
  Modal.setAppElement('#root');

  const handleClose = (): void => {
    close();
  };

  return (
    <Modal id={modalId} header="Troubleshooting Instructions" open={isOpen} close={handleClose} fixedToTop>
      <Modal.Content>
        <p>
          Looks like you may be having trouble with the training video or attestation. We’ve changed the training video
          to a non-YouTube video. Please close this message by clicking ‘X’. Then press play on the video and let it run
          in its entirety without skipping forward, rewinding, etc.
        </p>
        <p>
          If you are still unable to proceed, please contact support at{' '}
          <AriaLink
            link={ExternalLinks.E_VERIFY_PLUS_EMAIL}
            linkType={LinkType.EMAIL}
            customLinkText={ExternalLinks.E_VERIFY_PLUS_EMAIL}
          />
          . Please explain what errors you encountered, attach any screenshots, and include details such as your:
        </p>

        <ol className="padding-left-2">
          <li>Machine type (Mac, PC, iPad, iPhone, etc.)</li>
          <li>Browser type (Chrome, Edge, Firefox, Safari etc.)</li>
          <li>Browser version (For example: 128.0.6613.120)</li>
        </ol>
      </Modal.Content>
    </Modal>
  );
};

export default TroubleshootingModal;
